import { Box } from '@mui/material';
import LoginComponent from '../../components/Login/Login';
import Logo from '../../components/Login/Logo';

function Login() {
  return (
    <Box className='auth-page'>
      <Box className='center'>
        <Box className='body'>
          <Logo />
          <Box className='login-title-block' mt={2}>
            <Box className='login'>SIGN IN</Box>
          </Box>
          <LoginComponent />
        </Box>
      </Box>
    </Box>
  );
}

export default Login;
